export default __webpack_public_path__ + "static/media/google-logo.1dfbbd2d.svg";